module.exports = __webpack_public_path__ + "static/media/how-it-works.4a67658f.mp4";